<template>
  <div class="file-explorer-mobile">
    <v-subheader v-if="!folders.length && !files.length && !loadingError && !notInicialized && !notInicializedSalesforce">Esta pasta está vazia</v-subheader>

    <MobileActions :allowCreate="allowCreate" :allowUpload="allowUpload" @upload="(files) => $emit('upload', files)" @create-folder="(folderName) => $emit('create-folder', folderName)"/>

    <template v-if="folders.length">
      <v-subheader class="pa-2" style="background-color: var(--v-subHeaderBackground-base);">Pastas</v-subheader>
      <v-divider/>
      <template v-for="(folder, index) in folders">
        <Folder :allowDelete="allowDelete" :key="`folder-${index}`" :item="folder" @click="forward(index)"  @informations="informations"  @manualNotification="manualNotification" @delete="deleteItem" @rename="rename"/>
      </template>
    </template>

    <template v-if="files.length">
      <v-subheader class="pa-2" style="background-color: var(--v-subHeaderBackground-base);">Arquivos</v-subheader>
      <v-divider/>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn  v-on="on" outlined color="muted-accent" small class="my-3 p-0" style="border: 0" v-on:click="$emit('downloadAllFiles', files)" v-if="hasFiles()">
            <v-icon color="muted-accent">mdi-folder-download mdi-36px</v-icon>
          </v-btn>
        </template>
        <span>Download de todos os arquivos da pasta</span>
      </v-tooltip>
      <template v-for="(file, index) in files">
        <File :allowRename="allowRename" :allowDelete="allowDelete" :key="`file-${index}`" :item="file" @informations="informations" @download="download" @delete="deleteItem" @rename="rename"/>
      </template>
    </template>
  </div>
</template>

<script>
import Folder from '@/components/folder/index.vue';
import File from '@/components/file/index.vue';
import MobileActions from '@/components/mobile-actions/index.vue';

export default {
  name: 'GenericFileExplorerMobile',
  components: {
    Folder,
    File,
    MobileActions,
  },
  props: {
    folders: {
      type: Array,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    loadingError: {
      type: Boolean,
      required: true,
    },
    notInicialized: {
      type: Boolean,
      required: true,
    },
    notInicializedSalesforce: {
      type: Boolean,
      required: true,
    },
    allowCreate: {
      type: Boolean,
      required: true,
    },
    allowUpload: {
      type: Boolean,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
    allowRename: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    showingBottomFab: false,
  }),
  methods: {
    informations(item) {
      this.$emit('informations', item);
    },
    manualNotification(item) {
      this.$emit('manualNotification', item);
    },
    forward(index) {
      this.$emit('forward', index);
    },
    download(file, files) {
      this.$emit('download', file, files);
    },
    deleteItem(item) {
      this.$emit('delete', item);
    },
    rename(item) {
      this.$emit('rename', item);
    },
    hasFiles() {
      return this.files.length > 1;
    },
  },
};
</script>

<style lang="scss">

.file-explorer-mobile {
  padding-bottom: 100px;
}

.v-avatar {
  margin-left: 0;
}

.v-list-item {
  padding: 0;
}
</style>
